import chevronLeft from '@iconify/icons-feather/chevron-left';
import chevronRight from '@iconify/icons-feather/chevron-right';
import { InlineIcon } from '@iconify/react/dist/iconify';
import React from 'react';
import styled from 'styled-components';
import { cssVars } from '../../../app/styles';
import {
  MONTH_TITLE_HEIGHT,
  SWIMLANE_LABEL_PANE_WIDTH_PX,
} from '../../constants';

const { monthTitleBg, monthTitleFg } = cssVars.propertyHistoryColors;
const NavButtonContainer = styled.div`
  position: absolute;
  top: 0px;
  text-align: ${({ isLeft }) => (isLeft ? 'left' : 'right')};
  padding-left: ${({ isLeft }) => (isLeft ? '0px' : '50px')};
  padding-right: ${({ isLeft }) => (isLeft ? '30px' : '0px')};
  height: ${MONTH_TITLE_HEIGHT};
  background: linear-gradient(
    to ${({ isLeft }) => (isLeft ? 'right' : 'left')},
    ${monthTitleBg} 29%,
    ${monthTitleBg}00 50%
  );
  line-height: ${MONTH_TITLE_HEIGHT};
  color: ${monthTitleFg};
  > * {
    cursor: pointer;
  }
`;

const NavButtonText = styled.span`
  padding: 0 10px;
`;

// TODO: Accessibility fixes for nav buttons

const NavButton = ({ className, style, isLeft, children, onClick }) => (
  <NavButtonContainer isLeft={isLeft} style={style} className={className}>
    {/* eslint-disable-next-line max-len */}
    {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */}
    <NavButtonText onClick={onClick} role={'button'}>
      {children}
    </NavButtonText>
  </NavButtonContainer>
);

const LeftNavButton = styled(NavButton)`
  left: ${SWIMLANE_LABEL_PANE_WIDTH_PX}px;
`;

const RightNavButton = styled(NavButton)`
  right: 0px;
`;

export const MonthNavButtons = ({ onGoToNextMonth, onGoToPrevMonth }) => (
  <>
    <LeftNavButton isLeft onClick={onGoToPrevMonth}>
      {<InlineIcon icon={chevronLeft} />}
    </LeftNavButton>
    <RightNavButton onClick={onGoToNextMonth}>
      {<InlineIcon icon={chevronRight} />}
    </RightNavButton>
  </>
);
